/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import axios from "axios";
import BASE_URL from "config/Base_URL";
import { useState, useEffect } from "react";
// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const token = sessionStorage.getItem("token");
  const [totalCustomer, setTotalCustomer] = useState("");
  const [totalProduct, setTotalProduct] = useState("");
  const [totalSales, setTotalSales] = useState("");
  const [dataSales, setDataSales] = useState([]);
  const [salesChart, setSalesChart] = useState({
    labels: [],
    datasets: { label: "Penjualan", data: [] },
  });

  const convertDataToChart = (salesData) => {
    const currentYear = new Date().getFullYear(); // 2025

    const selectedYear = salesData.find((d) => d.years === currentYear);

    if (selectedYear) {
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const labels = [];
      const data = [];

      selectedYear.months.forEach((month, index) => {
        if (month.amountSales > 0) {
          labels.push(monthNames[index]); // 0-based index
          data.push(month.amountSales);
        }
      });

      setSalesChart({
        labels: labels,
        datasets: {
          label: "Penjualan",
          data: data,
        },
      });
    }
  };

  const fetchReport = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setTotalCustomer(response.data.data.totalCustomer);
      setTotalProduct(response.data.data.totalProduct);
      setTotalSales(response.data.data.totalSales);
      setDataSales(response.data.data.dataSales);
      console.log(response.data.data);
    } catch (error) {
      console.error("Gagal menampilkan produk:", error);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  useEffect(() => {
    if (dataSales.length > 0) {
      convertDataToChart(dataSales);
    }
  }, [dataSales]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="category"
                title="Produk"
                count={totalProduct}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                title="Penjualan"
                count={totalSales}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="local_mall"
                title="Customer"
                count={totalCustomer}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          {/* <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="local_atm"
                title="Pendapatan"
                count="34k"
                percentage={{
                  color: "success",
                  amount: "+1%",
                  label: "than yesterday",
                }}
              />
            </MDBox>
          </Grid> */}
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            {/* <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="dark"
                  title="Pembelian"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid> */}
            <Grid item xs={9}>
              <MDBox mb={3} height="100%">
                <ReportsLineChart
                  title="Penjualan"
                  description={<>Laporan penjualan per tahun</>}
                  date="Updated just now"
                  chart={salesChart}
                />
              </MDBox>
            </Grid>

            {/* <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="Pendapatan"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid> */}
          </Grid>
        </MDBox>
        {/* <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}>
              <Projects />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <OrdersOverview />
            </Grid>
          </Grid>
        </MDBox> */}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
